import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Order } from '@spike/order-model';
import { FunctionComponent, useMemo } from 'react';
import Pet from './Pet';
import PetParent from './PetParent';
import DateStartEndTime from './UI/DateStartEndTime';
import { groupOrderItemsByPet, sortPets } from './utils/OrderUtils';

export interface CheckoutOrderProps {
    order: Order;
    matchMemebrships?: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        section: {
            marginTop: 37,
            [theme.breakpoints.down('sm')]: {
                marginTop: 24
            }
        }
    })
);

export const CheckoutOrder: FunctionComponent<CheckoutOrderProps> = props => {
    const classes = useStyles(props);

    const sortedPets = useMemo(() => sortPets(props.order), [props.order]);

    const orderItemsByPet = useMemo(() => groupOrderItemsByPet(props.order), [props.order]);

    return (
        <>
            <PetParent
                client={props.order.client}
                matchMemebrships={props.matchMemebrships}
                className={classes.section}
            />
            <DateStartEndTime
                order={props.order}
                className={classes.section}
            />
            {sortedPets.map(
                pet =>
                    pet && (
                        <Pet
                            key={pet.id}
                            pet={pet}
                            className={classes.section}
                            petOrderItems={
                                orderItemsByPet.get(pet.id ?? 0) ?? {
                                    appointments: [],
                                    products: [],
                                    addOnServices: [],
                                    customs: [],
                                    memberships: []
                                }
                            }
                        />
                    )
            )}
        </>
    );
};

export default CheckoutOrder;
